import {flow, Lazy, pipe} from 'fp-ts/lib/function'
import {lt} from 'fp-ts/lib/Ord'
import {M, N, O, RA} from './fp-ts-imp'
import {Eq} from 'fp-ts/Eq'
import {Magma} from 'fp-ts/Magma'

export const runEffect = (f: () => void) => f()
export const penultimate = flow(RA.init, O.chain(RA.last))
export const lessThan = (second: number) => (first: number) =>
  lt(N.Ord)(first, second)
export const lessThan_ = (second: Lazy<number>) => (first: number) =>
  lt(N.Ord)(first, second())

const takeLast = <A>(): Magma<A> => ({
  concat: (f: A, l: A) => l,
})

export const mapFrom =
  <K, V>(eq: Eq<K>, fk: (v: V) => K) =>
  (vs: ReadonlyArray<V>): Map<K, V> =>
    pipe(
      vs,
      RA.map((v): [K, V] => [fk(v), v]),
      M.fromFoldable(eq, takeLast<V>(), RA.Foldable),
    )
